"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_complete_drive_html_1 = __importDefault(require("./instructor-complete-drive.html"));
var instructor_complete_drive_controller_1 = __importDefault(require("./instructor-complete-drive.controller"));
function getDriveSession($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.driveId).then(function (response) {
        return response.drive;
    });
}
getDriveSession.$inject = ["$stateParams", "DrivesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.completedrive", {
        url: "/drive/:driveId/complete",
        controller: instructor_complete_drive_controller_1.default,
        controllerAs: "vm",
        template: instructor_complete_drive_html_1.default,
        resolve: {
            driveSession: getDriveSession,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.completedrive", [])
    .controller("InstructorCompleteDriveController", instructor_complete_drive_controller_1.default)
    .config(config);
